import React from "react";
import { Form, Input, Button, Checkbox, Select } from "antd";

const { Option } = Select;

const RoleModalContent = ({ initialData, onSubmit, onCancel, permissions }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (initialData) {
      const initialPermissionIds =
        initialData.permissions?.map((p) => p.id) || [];
      form.setFieldsValue({
        ...initialData,
        permission_ids: initialPermissionIds,
      });
    } else {
      form.resetFields();
    }
  }, [initialData, form]);

  const onFinish = (values) => {
    onSubmit(values);
    setTimeout(() => {
      form.resetFields();
    }, 2000);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Form.Item
        name="name"
        label="Role Name"
        rules={[{ required: true, message: "Please input the role name!" }]}
      >
        <Input placeholder="Role Name" />
      </Form.Item>
      <Form.Item name="is_breeder_role" valuePropName="checked">
        <Checkbox>Breeder Role</Checkbox>
      </Form.Item>
      <Form.Item name="is_grower_role" valuePropName="checked">
        <Checkbox>Grower Role</Checkbox>
      </Form.Item>
      <Form.Item name="is_pollination_role" valuePropName="checked">
        <Checkbox>Pollination Role</Checkbox>
      </Form.Item>

      <Form.Item name="is_visible_for_assignment" valuePropName="checked">
        <Checkbox>Visible for User Assignment</Checkbox>
      </Form.Item>

      <Form.Item name="permission_ids" label="Permissions">
        <Select mode="multiple" placeholder="Select permissions">
          {permissions.map((perm) => (
            <Option key={perm.id} value={perm.id}>
              {perm.display_name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {initialData ? "Update" : "Create"}
        </Button>
        <Button className="ml-2" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};

export default RoleModalContent;
